import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Button } from 'Components';
import classNames from 'classnames';
import './Step.css';

const Step = (props) => {
  const stepClassName = classNames(
    'step',
    { 'step--active': props.isActive },
    { 'step--current': props.isCurrent },
    { 'step--disabled': props.isDisabled },
    props.className,
  );

  const stepLabelTextClass = classNames(
    'step__label__text',
    { 'step__label__text--active': props.isActive },
    { 'step__label__text--current': props.isCurrent },
    { 'step__label__text--french': i18n.language === 'F' },
  );

  return (
    <span className={stepClassName}>
      <Button onClick={props.onClick} disabled={props.isDisabled} type="button" >
        <span>
          {props.children}
        </span>
      </Button>
      <div className="step__label">
        <span className={stepLabelTextClass}>
          {i18n.t(`common:${props.text}`)}
        </span>
      </div>
    </span>
  );
};

Step.propTypes = {
  className: PropTypes.string,
  isActive: PropTypes.bool,
  isCurrent: PropTypes.bool,
  isDisabled: PropTypes.bool,
  children: PropTypes.node,
  onClick: PropTypes.func,
  text: PropTypes.string,
};

export default Step;



// WEBPACK FOOTER //
// ./src/components/Step/Step.jsx